export default __webpack_public_path__ + "static/media/i076jp.f53af22b.webp";